import Routers from "./Routes";



const App = () => {
  return ( 
    <div>
      <Routers/>
    </div>
   );
}
 
export default App;